export class JumbotronComponent {
    slides = [
        { id: 0, image: '/img/header-images/header-1.jpg' },
        { id: 1, image: '/img/header-images/header-2.jpg' },
        { id: 2, image: '/img/header-images/header-3.jpg' },
    ];
}

angular.module('tradersyard').component('tyHomeJumbotron', {
    template: `<div is-uib>
        <div uib-carousel active="active" interval="5000" no-wrap="false">
            <div uib-slide ng-repeat="slide in $ctrl.slides track by slide.id" index="slide.id">
                <img ng-src="{{slide.image}}" class="slider_image">
                <div class="carousel-caption">
                    <h4>Slide {{slide.id}}</h4>
                    <p>{{slide.text}}</p>
                </div>
            </div>
        </div>
</div>
    `,
    controller: JumbotronComponent,
});
